const SkeletonRow = () => (
  <tr className="border-b border-[#d0d4e4] dark:border-[#394564] animate-pulse">
    {[...Array(6)].map((_, i) => (
      <td key={i} className="py-4 px-3">
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-full" />
        {i === 0 && (
          <div className="h-3 bg-gray-100 dark:bg-gray-800 rounded w-1/2 mt-1" />
        )}
      </td>
    ))}
  </tr>
);

export default SkeletonRow;
